module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 100
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入手机"
    },
    model: {
      value: (_vm.filters.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone_number", $$v)
      },
      expression: "filters.phone_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入帐号"
    },
    model: {
      value: (_vm.filters.account),
      callback: function($$v) {
        _vm.$set(_vm.filters, "account", $$v)
      },
      expression: "filters.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入用户名"
    },
    model: {
      value: (_vm.filters.userName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userName", $$v)
      },
      expression: "filters.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择用户类型"
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openDetailFormVisible
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUserListExcel
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), (_vm.userInfo) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userInfo,
      "highlight-current-row": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone_number",
      "label": "手机号",
      "width": "120",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "帐号",
      "width": "60",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名",
      "width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "passwd",
      "label": "密码",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "software_type",
      "label": "软件类型",
      "width": "100",
      "align": "center",
      "formatter": _vm.softwareTypeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "用户类型",
      "width": "70",
      "align": "center",
      "formatter": _vm.typeFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buying_channels",
      "label": "渠道",
      "width": "70",
      "align": "center",
      "formatter": _vm.formatterBuying_channels
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group_name",
      "label": "微信群名",
      "width": "70",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effective_time",
      "label": "有效时间",
      "width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.effective_time.substring(0, 10)))])]
      }
    }], null, false, 1360271714)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status === 0 ? 'danger' : 'success',
            "size": "small"
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.status === 0 ? '禁用' : '激活') + "\n          ")])]
      }
    }], null, false, 423973550)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_date",
      "label": "创建时间",
      "width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.create_date.substring(0, 10)))])]
      }
    }], null, false, 2080520042)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_date",
      "label": "登录时间",
      "width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.last_login_date && typeof scope.row.last_login_date === 'string' ? scope.row.last_login_date.substring(0, 10) : ''))])]
      }
    }], null, false, 3355743460)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": scope.row.status === 1 ? 'warning' : 'success'
          },
          on: {
            "click": function($event) {
              return _vm.handleEditStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                         " + _vm._s(scope.row.status === 1 ? '禁用' : '激活') + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditReset(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleUnlock(scope.row)
            }
          }
        }, [_vm._v("解锁")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 3179185741)
  })], 1) : _c('div', [_vm._v("Loading...")]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": [20, 30, 50, 100, 200, 500, 1000],
      "page-size": _vm.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "80px",
      "rules": _vm.detailFormRules,
      "width": "200px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "帐号",
      "prop": "order_id"
    }
  }, [_c('el-input', {
    staticClass: "readonly-input",
    attrs: {
      "auto-complete": "off",
      "readonly": ""
    },
    model: {
      value: (_vm.detailForm.account),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "account", $$v)
      },
      expression: "detailForm.account"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "phone_number", $$v)
      },
      expression: "detailForm.phone_number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.username),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "username", $$v)
      },
      expression: "detailForm.username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "软件类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择软件类型"
    },
    model: {
      value: (_vm.detailForm.software_type),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "software_type", $$v)
      },
      expression: "detailForm.software_type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "人工贴标机"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "自动贴标机"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择用户类型"
    },
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.detailForm.type),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "type", $$v)
      },
      expression: "detailForm.type"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.passwd),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "passwd", $$v)
      },
      expression: "detailForm.passwd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "请选择有效期",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": _vm.defaultTime
    },
    model: {
      value: (_vm.detailForm.effective_time),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "effective_time", $$v)
      },
      expression: "detailForm.effective_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择渠道类型"
    },
    model: {
      value: (_vm.detailForm.buying_channels),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "buying_channels", $$v)
      },
      expression: "detailForm.buying_channels"
    }
  }, _vm._l((this.buying_channels), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信群名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.detailForm.group_name),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "group_name", $$v)
      },
      expression: "detailForm.group_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.detailForm.description),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "description", $$v)
      },
      expression: "detailForm.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb057e02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userManage/userManage.vue
// module id = 602
// module chunks = 1